import gql from 'graphql-tag'

const orgMemberVars = 'id role user { id name }'
export const listOrgVars = `id shortId name state status class members {${orgMemberVars}} insertedAt`
const orgDataVars = 'id type value'
const orgInvites = `id email expiresAt insertedAt requestor { id name } role used orgId`

const loadOrgVars = `
${listOrgVars}
data {${orgDataVars}}
pendingInvites {${orgInvites}}
`

export const ORG_ID_FROM_SHORT_ID = gql`
  query loadOrgTerse($id: String) {
    orgs(id: $id) {
      success
      reason
      results {
        ... on Org {
          id
        }
      }
    }
  }
`

export const LOAD_ORG = gql`
  query loadOrg($id: String) {
    orgs(id: $id) {
      success
      reason
      results {
        ... on Org { ${loadOrgVars} }
      }
    }
  }
`

export const ORG_LOGS = gql`
  query orgLogs($id: String, $start: DateTime, $end: DateTime) {
    orgs(id: $id) {
      success
      reason
      results {
        ... on Org {
          id
          activitys(start: $start, end: $end) {
            total
            matching
            results {
              id
              type {
                id
                name
              }
              actor {
                id
                name
              }
              resourceType
              resourceId
              billable
              insertedAt
            }
          }
        }
      }
    }
  }
`

// TODO: OrgServerRegistration should be more than just this, like registration3LoadVars,
// except this is registration2, not registration3...
export const UPDATE_ORG = gql`
  mutation orgUpsert($action: ChangeActions, $org: InputOrg, $data: InputOrgData, $registration: InputOrgRegistration) {
    orgChange(action: $action, org: $org, data: $data, registration: $registration) {
      success
      reason
      result {
        ... on Org { ${loadOrgVars} }
        ... on OrgServerRegistration { id name state claimer }
      }
    }
  }
`

export const PAYMENT_METHODS = gql`
  query paymentMethods($orgId: String!) {
    orgs(id: $orgId) {
      success
      reason
      results {
        ... on Org {
          id
          paymentMethods {
            id
            active
            expiresOn
            identifier
            insertedAt
            provider
            type
          }
        }
      }
    }
  }
`

export const SETUP_CUSTOMER = gql`
  mutation setupCustomer($orgId: String!) {
    orgChange(
      paymentMethod: { orgId: $orgId, action: PREPARE, type: CREDIT_CARD }
    ) {
      success
      reason
      result {
        ... on OrgPaymentMethod {
          id
          processor
          intent
          customerId
        }
      }
    }
  }
`

export const COMMIT_CUSTOMER = gql`
  mutation commitCustomer($orgId: String!, $activeId: String!) {
    orgChange(
      paymentMethod: {
        orgId: $orgId
        activeId: $activeId
        action: COMMIT
        type: CREDIT_CARD
      }
    ) {
      success
      reason
      result {
        ... on OrgPaymentMethod {
          id
          processor
          intent
          customerId
        }
      }
    }
  }
`

export const ORG_INVITE = gql`
  mutation orgInvite(
    $action: InviteAction!
    $id: String
    $email: String
    $note: String
    $orgId: String
    $role: OrgMemberRole
    $shortId: String
  ) {
    orgChange(
      invite: {
        action: $action
        id: $id
        role: $role
        shortId: $shortId
        orgId: $orgId
        note: $note
        email: $email
      }
    ) {
      success
      reason
      result {
        ... on OrgInvite {
          email
          note
          orgId
          role
        }
      }
    }
  }
`

export const MUTATE_ORG_MEMBER = gql`
  mutation changeOrgMember(
    $action: MemberAction!
    $id: String!
    $role: OrgMemberRole
  ) {
    orgChange(member: { id: $id, action: $action, role: $role }) {
      success
      reason
      result {
        ... on OrgMember {
          id
          role
        }
      }
    }
  }
`

//{action: REQUEST, registration: {quantity, skuId, podId}},
//results:
//{success=true, result: ... on OrgRegHold {id: holdId}}
//{success=false, reason=“Insufficient Servers”, result: {proposed: x}}
//{success=false, reason=“something else”}

// quantity, skuId, podId
export const REQUEST_HOLD = gql`
  mutation requestHold($registration: InputOrgRegistration) {
    orgChange(action: REQUEST, registration: $registration) {
      success
      reason
      result {
        ... on OrgRegHold {
          holdId
          amount
          expiresAt
        }
      }
    }
  }
`

// hold_id, ssh_key_id, os
export const ACCEPT_HOLD = gql`
  mutation acceptHold($registration: InputOrgRegistration) {
    orgChange(action: ACCEPT, registration: $registration) {
      success
      reason
      results {
        ... on OrgServerRegistration {
          id
        }
      }
    }
  }
`

export const CONTACT_SALES = gql`
  mutation requestSales($contactSales: InputContactSales!) {
    orgChange(action: REQUEST, contactSales: $contactSales) {
      success
      reason
      result {
        ... on Org {
          id
        }
      }
    }
  }
`
